<script>
import _ from 'lodash'
export default {
  data() {
    return {
      bbImage: 'images/bbb-image.png',
    }
  },
  computed: {
    siteID() {
      return _.get(this, '$store.state.referrer.referrerData.siteID', '0')
    },
  },
  methods: {
    navigateToHash(params) {
      this.$router.push(params)
    },
  },
}
</script>

<template>
  <div class="row" :class="$style.footer">
    <div class="container">
      <div class="row" :class="$style.footerLinksHeader">
        <div class="col d-none d-md-block"
          >AUTOCHECK&reg; VEHICLE HISTORY REPORTS</div
        >
        <div class="col d-none d-md-block">BUYING A USED CAR</div>
        <div class="col d-none d-md-block">CUSTOMER SERVICE</div>
        <div class="col d-none d-md-block">THE AUTOCHECK&reg; DIFFERENCE</div>
        <div class="col d-none d-md-block">WORK WITH US</div>
      </div>

      <div class="row" :class="$style.footerLinks">
        <div class="col d-none d-md-block">
          <ul class="list-unstyled">
            <li>
              <BaseLink :to="{ name: 'reports-list' }"
                >Order Vehicle History Reports</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'sample-report' }"
                >View a Sample Vehicle History Report</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'subscription-benefits' }"
                >VIN and License Plate Checks</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'search-by-license-plate' }"
                >Search By License Plate</BaseLink
              >
            </li>
          </ul>
        </div>
        <div class="col d-none d-md-block">
          <ul class="list-unstyled">
            <li>
              <BaseLink :to="{ name: 'autoshoppers-guide' }"
                >How To Buy A Used Car</BaseLink
              >
            </li>
            <!--<li>-->
            <!--<BaseLink :to="{ name: 'home' }">Find the Right Car</BaseLink>-->
            <!--</li>-->
            <!--<li>-->
            <!--<BaseLink :to="{ name: 'home' }"-->
            <!--&gt;Research the Vehicle's History</BaseLink-->
            <!--&gt;-->
            <!--</li>-->
            <!--<li>-->
            <!--<BaseLink :to="{ name: 'home' }"-->
            <!--&gt;Run a Visual Check of the Used Vehicle</BaseLink-->
            <!--&gt;-->
            <!--</li>-->
            <!--<li>-->
            <!--<BaseLink :to="{ name: 'home' }"-->
            <!--&gt;Get a Vehicle Inspection</BaseLink-->
            <!--&gt;-->
            <!--</li>-->
            <!--<li>-->
            <!--<BaseLink :to="{ name: 'home' }">Secure Financing</BaseLink>-->
            <!--</li>-->
            <!--<li>-->
            <!--<BaseLink :to="{ name: 'home' }">Insure Your Vehicle</BaseLink>-->
            <!--</li>-->
            <li>
              <BaseLink :to="{ name: 'vin-basics' }">What is a VIN?</BaseLink>
            </li>
            <li>
              <BaseLink :to="{ name: 'vin-basics', hash: '#decode' }"
                >VIN Decode Explained</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'vin-basics', hash: '#findvin' }"
                >Where Can I Find the VIN?</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'odometer-fraud' }"
                >Protect Yourself from Odometer Fraud</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'title-brands' }"
                >Learn About Title Brands</BaseLink
              >
            </li>
          </ul>
        </div>
        <div class="col d-none d-md-block list-unstyled">
          <ul class="list-unstyled">
            <li>
              <BaseLink :to="{ name: 'faq' }"
                >Frequently Asked Questions</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'contact' }">Contact Us</BaseLink>
            </li>
            <li>
              <BaseLink :to="{ name: 'free-online-delivery' }"
                >Free Digital Dashboard Delivery</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'secure-shopping' }"
                >Secure Shopping</BaseLink
              >
            </li>
            <li>
              <BaseLink href="https://www.experian.com/privacy/auto_check"
                >Your Data Safety and Personal Privacy</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'glossary' }"
                >Glossary of Vehicle History Terms</BaseLink
              >
            </li>
          </ul>
        </div>
        <div class="col d-none d-md-block list-unstyled">
          <ul class="list-unstyled">
            <li>
              <BaseLink :to="{ name: 'autocheck-score' }"
                >The Patented AutoCheck Score&reg;</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'patent-notice' }"
                >U.S. Patent No. 8,005,759</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'vehicle-buyback-protection' }"
                >Vehicle Buyback Protection</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'backed-by-experian' }"
                >Data Backed by Experian</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'autocheck-vs-carfax' }"
                >AutoCheck v. Carfax</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'autocheck-vs-bargain' }"
                >AutoCheck v. Bargain Reports</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'flood-risk' }">Flood Risk Check</BaseLink>
            </li>
          </ul>
        </div>
        <div class="col d-none d-md-block">
          <ul class="list-unstyled">
            <li>
              <BaseLink
                href="https://www.experian.com/automotive/autocheck-business#consumer?cmpid=auto_AutoCheckConsumer_web"
                >Auto Dealer? Become an AutoCheck Member</BaseLink
              >
            </li>
            <li>
              <BaseLink :to="{ name: 'affiliate-program' }"
                >Online Advertiser? Join the AutoCheck Affiliate
                Program</BaseLink
              >
            </li>
            <li>
              <BaseLink
                href="https://www.experian.com/corporate/careers-home.html"
                >Experian Careers</BaseLink
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="text-center" :class="$style.terms">
        <ul class="list-inline">
          <li class="list-inline-item">
            <BaseLink :to="{ name: 'terms-of-use' }"
              >AutoCheck Terms and Conditions</BaseLink
            >
          </li>
          <li class="list-inline-item">|</li>
          <li class="list-inline-item">
            <BaseLink href="http://www.experian.com/corporate/legalterms.html"
              >Experian Terms and Conditions</BaseLink
            >
          </li>
          <li class="list-inline-item">|</li>
          <li class="list-inline-item">
            <!-- <BaseLink :to="{ name: 'privacy-policy' }">Privacy Policy</BaseLink> -->
            <BaseLink href="https://www.experian.com/privacy/auto_check"
              >Privacy Policy</BaseLink
            >
          </li>
          <li class="list-inline-item">|</li>
          <li class="list-inline-item">
            <BaseLink :to="{ name: 'your-ad-choices' }"
              >Your Ad Choices</BaseLink
            >
          </li>
        </ul>
      </div>
      <div class="text-center"
        >&copy;Experian {{ new Date().getFullYear() }}. All rights reserved</div
      >
      <input id="siteID" v-model="siteID" type="hidden" name="siteID" />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.footer {
  position: relative;
  z-index: 1;
  padding-top: 30px;
  padding-bottom: 30px;
  margin-top: 40px;
  font-size: 12px;
  color: white;
  background: #252525;
  ul {
    padding-left: 0;
    li {
      @media screen and (max-width: 768px) {
        margin-top: 8px;
      }
    }
  }

  a {
    color: #fff;
    text-decoration: none;
    &:active,
    :hover,
    :visited {
      color: #fff;
    }
    &:hover {
      text-decoration: underline;
    }
  }
}

.terms {
  margin-top: 15px;
  margin-bottom: 20px;
}

.footerLinksHeader {
  margin-top: 30px;
  font-weight: bold;

  li {
    margin-top: 3px;
  }
}

.footerLinks {
  margin-top: 20px;

  li {
    margin-top: 3px;
  }
}

.logo {
  padding: 2px;
}
</style>
